import React from "react";
import cn from "classnames";
import { i18n } from "@src/i18n/i18n";
import { Icon } from "@components/atoms/icon/icon";
import styles from "./logout-icon-button.module.scss";

interface LogoutIconButtonPropTypes {
  ariaLabel?: string;
  iconName: string;
  isIconActive: boolean;
  height?: number;
  width?: number;
  handleClick: () => void;
}

const DEFAULT_ARIA_LABEL = i18n("navigation.logoutButton");
const DEFAULT_ICON_NAME = "logout";
const DEFAULT_HEIGHT = 24;
const DEFAULT_WIDTH = 24;
const cssClassName = "logout-icon-button";

export const LogoutIconButton = ({
  ariaLabel = DEFAULT_ARIA_LABEL,
  isIconActive,
  iconName = DEFAULT_ICON_NAME,
  height = DEFAULT_HEIGHT,
  width = DEFAULT_WIDTH,
  handleClick,
}: LogoutIconButtonPropTypes) => (
  <button
    type="button"
    className={cn(
      styles[cssClassName],
      styles[`${cssClassName}__hover`],
      styles[`${cssClassName}__center-content`],
      {
        [styles[`${cssClassName}__active`]]: isIconActive,
      },
    )}
    onClick={handleClick}
    aria-label={ariaLabel}
  >
    <Icon name={iconName} width={width} height={height} />
  </button>
);
